// extracted by mini-css-extract-plugin
export var blue = "_31-g";
export var brand = "_31-c";
export var darkGrey = "_31-f";
export var disabled = "_31-6";
export var disabledSubtle = "_31-7";
export var error = "_31-8";
export var green = "_31-h";
export var grey = "_31-e";
export var icon = "_31-0";
export var inherit = "_31-b";
export var lightGrey = "_31-d";
export var orange = "_31-j";
export var pink = "_31-l";
export var primary = "_31-1";
export var purple = "_31-m";
export var quaternary = "_31-4";
export var quinary = "_31-5";
export var red = "_31-k";
export var secondary = "_31-2";
export var success = "_31-a";
export var tertiary = "_31-3";
export var warning = "_31-9";
export var white = "_31-n";
export var yellow = "_31-i";